module.exports = __webpack_public_path__ + "static/mehtaab-brar-3ac1b0ab3ec78598e7c00dcc25966667.jpg";